/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Tlm_1Inputs */

const en_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`print_network`)
};

const ar_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شبكة الطباعة`)
};

const bn_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রিন্ট নেটওয়ার্ক`)
};

const de_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druck-Netzwerk`)
};

const es_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red de impresión`)
};

const fr_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseau d'impression`)
};

const pt_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rede de impressão`)
};

const zh_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印网络`)
};

const tr_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baskı ağı`)
};

const ru_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сеть печати`)
};

const pl_svc_ai_image_pod_automation_tlm_1 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieć druku`)
};

/**
* | output |
* | --- |
* | "print_network" |
*
* @param {Svc_Ai_Image_Pod_Automation_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_tlm_1 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_tlm_1(inputs)
	return en_svc_ai_image_pod_automation_tlm_1(inputs)
});
export { svc_ai_image_pod_automation_tlm_1 as "svc_ai-image-pod-automation_tlm_1" }